import { Card as CardType } from "../types";
import { BATTLE_CARDS } from "./battle";
import { CURSE_CARDS } from "./curse";
import { DARE_CARDS } from "./dare";
import { QUESTION_CARDS } from "./question";
import { TRUTH_CARDS } from "./truth";
import { WILD_CARDS } from "./wildcard";
import { WYR_CARDS } from "./wyr";
import { GAMBLE_CARDS } from "./gamble";
import { CHAOS_CARDS } from "./chaos";

export const ALL_CARDS: CardType[] = [
  ...CURSE_CARDS,
  ...DARE_CARDS,
  ...QUESTION_CARDS,
  ...TRUTH_CARDS,
  ...BATTLE_CARDS,
  ...GAMBLE_CARDS,
  ...WILD_CARDS,
  ...WYR_CARDS,
  ...CHAOS_CARDS,
];
